import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="#202020"
        fillOpacity='0.5'
        d="M11.333 4h3.334v1.333h-1.334V14a.667.667 0 01-.666.667H3.333A.666.666 0 012.667 14V5.333H1.333V4h3.334V2a.667.667 0 01.666-.667h5.334a.667.667 0 01.666.667v2zM12 5.333H4v8h8v-8zm-6 2h1.333v4H6v-4zm2.667 0H10v4H8.667v-4zM6 2.667V4h4V2.667H6z"
      ></path>
    </svg>
  )
}

export default Icon
